import { Node, useEditor } from '@craftjs/core';

// Registry of component types (resolver keys) that should have editable settings
const EDITABLE_COMPONENTS_REGISTRY = new Set([
  'PresentationListItem',
  'EditableEducationalSlideBody',
  'EducationalSlideHeading',
  'EditableCallout',
]);

// Components that are containers/canvases - when selected, we should look for an editable parent
const CONTAINER_COMPONENTS = new Set(['BlockEditorCanvas']);

export function useSelectedEditableNode() {
  const { selected } = useEditor((state) => {
    const currentNodeId = state.events.selected.values().next().value;

    let selected: Node | undefined;
    if (currentNodeId) {
      let node = state.nodes[currentNodeId];

      // If the selected node is a container (like BlockEditorCanvas),
      // walk up the tree to find an editable parent
      let iterations = 0;
      while (node && CONTAINER_COMPONENTS.has(node.data.name)) {
        const parentId = node.data.parent;
        if (parentId) {
          node = state.nodes[parentId];
        } else {
          break;
        }
        iterations++;
        if (iterations > 10) {
          break;
        }
      }

      if (node) {
        // Only create selected object if component is in the editable registry
        if (EDITABLE_COMPONENTS_REGISTRY.has(node.data.name)) {
          selected = {
            ...node,
          };
        }
      }
    }

    return {
      selected,
    };
  });

  // Get actions and query outside the selector for better performance
  const { actions, query } = useEditor();

  return {
    selected,
    actions,
    query,
  };
}
